import * as Yup from 'yup';

const requiredText = () => Yup.string().trim().required('Required');

export const descriptionOfRiskRowSchema = () =>
  Yup.object({
    descriptionOfRisk: requiredText(),
    geoLocation: requiredText()
  });

export const descriptionOfRiskValidationSchema = () =>
  Yup.object({
    descriptionOfRiskDetails: Yup.array()
      .of(descriptionOfRiskRowSchema())
      .min(1, 'At least one row is required')
  });
